
function createLightbox(image, caption) {
    const lightBoxContainer = document.createElement("div");
    const lightBoxContent = document.createElement("div");
    const lightBoxImg = document.createElement("img");

    lightBoxContainer.classList.add("lightbox");
    lightBoxContent.classList.add("lightbox-content");

    lightBoxContainer.appendChild(lightBoxContent);
    lightBoxContent.appendChild(lightBoxImg);

    // caption
    if (caption) {
        const lightBoxCaption = document.createElement("div");
        lightBoxCaption.classList.add('lightbox-caption');
        lightBoxCaption.textContent = caption;
        lightBoxContent.appendChild(lightBoxCaption);
    }

    document.body.appendChild(lightBoxContainer);
    lightBoxContainer.style.display = "block";
    lightBoxImg.setAttribute("src", image);

    function closeLightBox() {
        if (this === event.target) {
            lightBoxContainer.style.display = "none";
        }
    }

    lightBoxContainer.addEventListener("click", closeLightBox);
}

export {createLightbox};